import { render, staticRenderFns } from "./borderSvg.vue?vue&type=template&id=5ec79fdf&scoped=true"
import script from "./borderSvg.vue?vue&type=script&lang=js"
export * from "./borderSvg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ec79fdf",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zhenzhaopin\\xxh-zhaopin-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5ec79fdf')) {
      api.createRecord('5ec79fdf', component.options)
    } else {
      api.reload('5ec79fdf', component.options)
    }
    module.hot.accept("./borderSvg.vue?vue&type=template&id=5ec79fdf&scoped=true", function () {
      api.rerender('5ec79fdf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/costPlatform/components/widgets/basic_image/borderSvg.vue"
export default component.exports